/* ══════════════════════════════════════════════════════════════
   Earnings Tracker — Results with Beat/Miss Indicators
   ══════════════════════════════════════════════════════════════ */

export interface EarningsResult {
    company: string;
    symbol: string;
    date: string;
    revenue: number;
    revEstimate: number;
    pat: number;
    patEstimate: number;
    verdict: 'beat' | 'miss' | 'inline';
    stockReaction: number;
}

export function renderEarningsTracker(container: HTMLElement, results?: EarningsResult[]): void {
    const data: EarningsResult[] = results || [
        { company: 'HDFC Bank', symbol: 'HDFCBANK', date: 'Jan 20', revenue: 68500, revEstimate: 66000, pat: 16800, patEstimate: 16200, verdict: 'beat', stockReaction: 2.3 },
        { company: 'TCS', symbol: 'TCS', date: 'Jan 13', revenue: 64200, revEstimate: 63500, pat: 12500, patEstimate: 12800, verdict: 'miss', stockReaction: -1.2 },
        { company: 'Infosys', symbol: 'INFY', date: 'Jan 11', revenue: 41500, revEstimate: 41000, pat: 6820, patEstimate: 6800, verdict: 'inline', stockReaction: 0.3 },
        { company: 'Reliance', symbol: 'RELIANCE', date: 'Jan 17', revenue: 265000, revEstimate: 260000, pat: 19200, patEstimate: 18500, verdict: 'beat', stockReaction: 1.8 },
        { company: 'ICICI Bank', symbol: 'ICICIBANK', date: 'Jan 22', revenue: 45200, revEstimate: 44000, pat: 11800, patEstimate: 11500, verdict: 'beat', stockReaction: 1.5 },
    ];

    const verdictBadge = (v: string) => {
        const map: Record<string, { color: string; label: string; emoji: string }> = {
            beat: { color: '#059669', label: 'BEAT', emoji: '✅' },
            miss: { color: '#dc2626', label: 'MISS', emoji: '❌' },
            inline: { color: '#d97706', label: 'INLINE', emoji: '➡️' },
        };
        const m = map[v] || map.inline;
        return `<span class="verdict-badge" style="background:${m.color}20;color:${m.color}">${m.emoji} ${m.label}</span>`;
    };

    const fmt = (n: number) => `₹${(n / 100).toFixed(0)} Cr`;

    const rows = data.map(r => `
    <tr>
      <td><strong>${r.company}</strong><br><small>${r.symbol}</small></td>
      <td>${r.date}</td>
      <td>${fmt(r.revenue)} <small class="${r.revenue >= r.revEstimate ? 'up' : 'down'}">(est: ${fmt(r.revEstimate)})</small></td>
      <td>${fmt(r.pat)} <small class="${r.pat >= r.patEstimate ? 'up' : 'down'}">(est: ${fmt(r.patEstimate)})</small></td>
      <td>${verdictBadge(r.verdict)}</td>
      <td class="${r.stockReaction >= 0 ? 'up' : 'down'}">${r.stockReaction >= 0 ? '+' : ''}${r.stockReaction}%</td>
    </tr>`).join('');

    container.innerHTML = `
    <div class="earnings-tracker glass-card">
      <div class="card-header">
        <h3>📊 Earnings Results</h3>
        <span class="earnings-season">Q3 FY26 Season</span>
      </div>
      <div class="table-responsive">
        <table class="earnings-table">
          <thead>
            <tr><th>Company</th><th>Date</th><th>Revenue</th><th>PAT</th><th>Verdict</th><th>Stock</th></tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    </div>`;
}
